/**
 * Тексты ошибок робота для WS-событий `mqtt.control` и `mqtt.download_mission_confirm`.
 *
 * Бэкенд присылает только int-код ошибки (0 = success), в человекочитаемый
 * текст его превращает фронт. Тексты перенесены 1:1 из бывших backend-констант
 * MODE_STATUSES / DOWNLOAD_MISSION_ERROR_CODES, чтобы не менять UX.
 */

export const CONTROL_ERROR_SUCCESS = 0
export const DOWNLOAD_ERROR_SUCCESS = 0

export const CONTROL_ERROR_MESSAGES: Record<number, string> = {
  0: 'Success',
  1: 'Robot is already executing the requested control',
  11: 'Request processing time exceeded',
  12: 'Error parsing request message content',
  13: 'Unsupported requested mode/action',
  14: 'Mission reading error when switching to INTELLIGENT mode',
  15: 'Internal error processing request',
  16: 'Impossible to perform actions in the current mode',
  255: 'Unknown error',
}

export const DOWNLOAD_ERROR_MESSAGES: Record<number, string> = {
  0: 'Success',
  1: 'A mission file with this name and hash has already been uploaded.',
  11: 'Request processing time exceeded',
  12: 'Error parsing request message content',
  13: 'Another loading process is already in progress',
  14: 'Error initializing library for http download request',
  15: 'Error opening file to save to disk',
  16: 'Wrong URL',
  17: 'Md5sum calculation library initialization error',
  18: 'Error comparing the hash of the uploaded file',
  255: 'Unknown error',
}

export const getControlErrorMessage = (code: number): string =>
  CONTROL_ERROR_MESSAGES[code] ?? `Unknown error code: ${code}`

export const getDownloadErrorMessage = (code: number): string =>
  DOWNLOAD_ERROR_MESSAGES[code] ?? `Unknown error code: ${code}`
